module.exports = __webpack_public_path__ + "img/submit.a424be55.png";